const SENDBIRD_MESSAGE_INPUT_SELECTORS = [
  ".sendbird-message-input-text-field",
  "[contenteditable='true'][data-testid='sendbird.channel.messageInput']",
  "[contenteditable='true']",
];

export const focusChatInput = () => {
  for (const selector of SENDBIRD_MESSAGE_INPUT_SELECTORS) {
    const element = document.querySelector(selector);
    if (element instanceof HTMLElement) {
      element.focus();
      return;
    }
  }
};
